import { Component } from '@angular/core';

@Component({
  selector: 'app-nutriscore-modal-fr',
  templateUrl: './nutriscore-modal-fr.component.html',
  styleUrls: ['./nutriscore-modal-fr.component.scss'],
  standalone: false,
})
export class NutriscoreModalFrComponent {}
